// FILE: shellSnapshot.ts
// Purpose: Ask the server to re-send the shell snapshot after an out-of-band write.
// Layer: Web transport helper
// Exports: refreshShellSnapshot

import { readNativeApi } from "../nativeApi";

/**
 * Re-request the shell snapshot so projects reflect a change the event log
 * never saw.
 *
 * Most project state reaches the sidebar as domain events, which the server
 * pushes on its own. A few fields do not: the Plane board link and the stored
 * PAT are written straight to `projection_projects` by the admin routes, so
 * nothing is published and every open client keeps the project it was given at
 * connect time — the settings screen would say "linked" while the project's
 * context menu still offered no Plane entry.
 *
 * `subscribeShell` is idempotent on the server and answers with a fresh
 * snapshot, which is exactly what is needed here. It only refreshes *this*
 * client: another browser tab picks the change up on its next connect. That is
 * the honest limit of writing outside the log, and linking a board is a rare
 * admin action, so it buys correctness where it matters without putting the same
 * data on two write paths.
 */
export function refreshShellSnapshot(): void {
  const api = readNativeApi();
  if (!api) return;
  void api.orchestration.subscribeShell().catch(() => undefined);
}
